import { ILoadingStatus } from 'models/general';
import { actionMapForDataLoaders, actionMapForOtherLoaders } from '../../../constants';

type ActionKeys = keyof typeof actionMapForDataLoaders;
type ActionValues = typeof actionMapForDataLoaders[ActionKeys];

export interface ILoaderState {
  dataLoaders?: {
    [key in ActionValues]: ILoadingStatus;
  };
  otherLoaders?: {
    [key in ActionValues]: ILoadingStatus;
  };
  hasData?: boolean;
  updatedAt?: string | null;
  updatedBy?: string | null;
  total?: number;
  completed?: any[];
  isFetchingData?: boolean;
}

const initialState: ILoaderState = {
  dataLoaders: {},
  otherLoaders: {},
  hasData: false,
  updatedAt: null,
  updatedBy: null,
  total: 33,
  completed: [],
  isFetchingData: false,
};

Object.values(actionMapForDataLoaders).forEach(key => {
  initialState.dataLoaders[key] = {
    isLoading: false,
    hasErrors: null,
    errors: {},
  };
});

Object.values(actionMapForOtherLoaders).forEach(key => {
  initialState.otherLoaders[key] = {
    isLoading: false,
    hasErrors: null,
    errors: {},
  };
});

export default initialState;
